<template>
<form @submit.prevent="submit" id="gateway_form">
    <div class="container p-3 pt-5 my-4 border in-border-header">
        <kt-form-section is_first>
            <div class="section-header bg-white">
                {{ $t('label.complete_personal_data') }}
            </div>
            <kt-row>
                <kt-col lg="4" md="4" xs="12">
                    <kt-form-group>
                        <kt-form-label for="merchant_type">
                            {{ $t('label.merchant_type') }}
                        </kt-form-label>
                        <select
                                id="merchant_type"
                                name="merchant_type"
                                v-model="form_data.merchant_type"
                                class="form-control kt-selectpicker"
                                disabled
                        >
                            <option value=0>
                                {{ $t('label.real') }}
                            </option>
                            <option value=1>
                                {{ $t('label.legal') }}
                            </option>
                        </select>
                    </kt-form-group>
                </kt-col>
            </kt-row>
            <kt-row v-if="form_data.merchant_type == 1">
                <kt-col lg="6" md="6" xs="12">
                    <kt-form-group>
                        <kt-form-label for="com_name_fa">
                            {{ $t('label.com_name_fa') }}
                        </kt-form-label>
                        <kt-form-control
                                id="com_name_fa"
                                name="com_name_fa"
                                v-model="form_data.com_name_fa"
                                :disabled="checkIfShopRejectedByShaparak() || current_user.user_type == user_types.LEGAL"
                        >
                        </kt-form-control>
                    </kt-form-group>
                </kt-col>
                <kt-col lg="6" md="6" xs="12">
                    <kt-form-group>
                        <kt-form-label for="com_name_en">
                            {{ $t('label.com_name_en') }}
                        </kt-form-label>
                        <kt-form-control
                                id="com_name_en"
                                name="com_name_en"
                                dir="ltr"
                                v-model="form_data.com_name_en"
                                :disabled="checkIfShopRejectedByShaparak() || current_user.user_type == user_types.LEGAL"
                        >
                        </kt-form-control>
                    </kt-form-group>
                </kt-col>
                <kt-col lg="4" md="4" xs="12">
                    <kt-form-group>
                        <kt-form-label for="national_legal_code">
                            {{ $t('label.national_legal_code') }}
                        </kt-form-label>
                        <kt-form-control
                                id="national_legal_code"
                                name="national_legal_code"
                                v-model="form_data.national_legal_code"
                                :disabled="checkIfShopRejectedByShaparak() || current_user.user_type == user_types.LEGAL"
                        >
                        </kt-form-control>
                    </kt-form-group>
                </kt-col>
                <kt-col lg="4" md="4" xs="6">
                    <kt-form-group>
                        <kt-form-label for="register_number">
                            {{ $t('label.register_number') }}
                        </kt-form-label>
                        <kt-form-control
                                id="register_number"
                                name="register_number"
                                v-model="form_data.register_number"
                                :disabled="checkIfShopRejectedByShaparak() || current_user.user_type == user_types.LEGAL"
                        >
                        </kt-form-control>
                    </kt-form-group>
                </kt-col>
                <kt-col lg="4" md="4" xs="12">
                    <kt-form-group>
                        <kt-form-label for="register_date">
                            {{ $t('label.com_register_date') }}
                        </kt-form-label>
                        <datePicker
                                color="#00c1a4"
                                format="YYYY-MM-DD HH:mm:ss"
                                display-format="jDD jMMMM jYYYY"
                                input-class="form-control"
                                id="register_date"
                                name="register_date"
                                v-model="form_data.register_date"
                                type="date"
                                :disabled="checkIfShopRejectedByShaparak() || current_user.user_type == user_types.LEGAL"
                        />
                    </kt-form-group>
                </kt-col>
            </kt-row>
        </kt-form-section>
    </div>
    <kt-col class="container p-3 pt-5 my-4 border in-border-header">
        <kt-form-section>
            <div class="section-header bg-white">
                {{ $t('label.shop_data') }}
            </div>
            <kt-row>
                <kt-col lg="6" md="6" xs="12">
                    <kt-form-group>
                        <kt-form-label for="farsi_name">
                            {{ $t('label.farsi_name') }}
                        </kt-form-label>
                        <kt-form-control
                            id="farsi_name"
                            name="farsi_name"
                            :disabled="checkIfShopRejectedByShaparak()"
                            v-model="form_data.farsi_name"
                        >
                        </kt-form-control>
                    </kt-form-group>
                </kt-col>

                <kt-col lg="6" md="6" xs="12">
                    <kt-form-group>
                        <kt-form-label for="english_name">
                            {{ $t('label.english_name') }}
                        </kt-form-label>
                        <kt-form-control
                            id="english_name"
                            name="english_name"
                            :disabled="checkIfShopRejectedByShaparak()"
                            v-model="form_data.english_name"
                            dir="ltr"
                        >
                        </kt-form-control>
                    </kt-form-group>
                </kt-col>
            </kt-row>
            <kt-row>
                <kt-col lg="12" md="12" xs="12">
                    <kt-form-group>
                        <kt-form-label for="subcategory_code">
                            {{ $t('label.subcategory_code') }}
                        </kt-form-label>
                        <select
                            id="subcategory_code"
                            name="subcategory_code"
                            :disabled="checkIfShopRejectedByShaparak()"
                            v-model="form_data.subcategory_code"
                            class="form-control kt-selectpicker"
                        >
                            <option
                                v-bind:key="subcategory.key"
                                v-for="subcategory in subcategories"

                                :value="subcategory.key"
                            >
                                {{ subcategory.value }}
                            </option>
                        </select>
                    </kt-form-group>
                </kt-col>
            </kt-row>
            <kt-row v-if="form_data.merchant_type == 1">
                <kt-col lg="12" md="12" xs="12">
                    <kt-row>
                        <kt-col lg="6" md="6" xs="12">
                            <kt-form-group>
                                <kt-form-label for="provinces">
                                    {{ $t('label.province') }}
                                </kt-form-label>
                                <select
                                    id="provinces"
                                    name="provinces"
                                    v-model="form_data.province_code"
                                    class="form-control kt-selectpicker"
                                >
                                    <option
                                        v-bind:key="province.id"
                                        v-for="province in provinceCodes"
                                        :selected="form_data.province_code == province.province_code"
                                        :value="province.province_code"
                                    >
                                        <span>{{ province.name }}</span>
                                    </option>
                                </select>
                            </kt-form-group>
                        </kt-col>
                        <kt-col lg="6" md="6" xs="12">
                            <kt-form-group>
                                <kt-form-label for="cities">
                                    {{ $t('label.city') }}
                                </kt-form-label>
                                <select
                                    id="cities"
                                    name="cities"
                                    v-model="form_data.city_code"
                                    class="form-control"
                                >
                                    <option
                                        v-bind:key="city.city_code + '-' + city_index"
                                        v-for="(city, city_index) in getProvinceCities"
                                        :selected="form_data.city_code == city.city_code"
                                        :value="city.city_code"
                                    >
                                        <span>{{ city.name }}</span>
                                    </option>
                                </select>
                            </kt-form-group>
                        </kt-col>
                    </kt-row>
                </kt-col>
                <kt-col lg="6" md="6" xs="12">
                    <kt-form-group>
                        <kt-form-label for="address">
                            {{ $t('label.address') }}
                        </kt-form-label>
                        <select
                            v-if="addresses"
                            id="address"
                            name="address"
                            :disabled="checkIfShopRejectedByShaparak()"
                            v-model="form_data.address"
                            class="form-control kt-selectpicker"
                        >
                            <option
                                v-bind:key="address.id"
                                v-for="address in addresses"

                                :value="address.id"
                            >
                                {{ address.address }}
                            </option>
                        </select>
                    </kt-form-group>
                </kt-col>
                <kt-col lg="3" md="3" xs="12">
                    <kt-form-group>
                        <kt-form-label for="telephone">
                            {{ $t('label.telephone') }}
                        </kt-form-label>
                        <kt-form-control
                            dir="ltr"
                            id="telephone"
                            name="telephone"
                            :disabled="checkIfShopRejectedByShaparak()"
                            v-model="form_data.telephone"
                        >
                        </kt-form-control>
                    </kt-form-group>
                </kt-col>
                <kt-col lg="3" md="3" xs="12">
                    <kt-form-group>
                        <kt-form-label for="tax_payer_code">
                            {{ $t('label.tax_payer_code') }}
                        </kt-form-label>
                        <kt-form-control
                                dir="ltr"
                                id="tax_payer_code"
                                name="tax_payer_code"
                                :disabled="checkIfShopRejectedByShaparak()"
                                v-model="form_data.tax_payer_code"
                        >
                        </kt-form-control>
                    </kt-form-group>
                </kt-col>
            </kt-row>
            <kt-row v-else>
                <kt-col lg="12" md="12" xs="12">
                    <kt-row>
                        <kt-col lg="6" md="6" xs="12">
                            <kt-form-group>
                                <kt-form-label for="provinces">
                                    {{ $t('label.province') }}
                                </kt-form-label>
                                <select
                                    id="provinces"
                                    name="provinces"
                                    v-model="form_data.province_code"
                                    class="form-control kt-selectpicker"
                                >
                                    <option
                                        v-bind:key="province.id"
                                        v-for="province in provinceCodes"
                                        :selected="form_data.province_code == province.province_code"
                                        :value="province.province_code"
                                    >
                                        <span>{{ province.name }}</span>
                                    </option>
                                </select>
                            </kt-form-group>
                        </kt-col>
                        <kt-col lg="6" md="6" xs="12">
                            <kt-form-group>
                                <kt-form-label for="cities">
                                    {{ $t('label.city') }}
                                </kt-form-label>
                                <select
                                    id="cities"
                                    name="cities"
                                    v-model="form_data.city_code"
                                    class="form-control"
                                >
                                    <option
                                        v-bind:key="city.city_code + '-' + city_index"
                                        v-for="(city, city_index) in getProvinceCities"
                                        :selected="form_data.city_code == city.city_code"
                                        :value="city.city_code"
                                    >
                                        <span>{{ city.name }}</span>
                                    </option>
                                </select>
                            </kt-form-group>
                        </kt-col>
                    </kt-row>
                </kt-col>
                <kt-col lg="6" md="6" xs="12">
                    <kt-form-group>
                        <kt-form-label for="address">
                            {{ $t('label.address') }}
                        </kt-form-label>
                        <select
                            v-if="addresses"
                            id="address"
                            name="address"
                            :disabled="checkIfShopRejectedByShaparak()"
                            v-model="form_data.address"
                            class="form-control kt-selectpicker"
                        >
                            <option
                                v-bind:key="address.id"
                                v-for="address in addresses"

                                :value="address.id"
                            >
                                {{ address.address }}
                            </option>
                        </select>
                    </kt-form-group>
                </kt-col>

                <kt-col lg="6" md="6" xs="12">
                    <kt-form-group>
                        <kt-form-label for="telephone">
                            {{ $t('label.telephone') }}
                        </kt-form-label>
                        <kt-form-control
                            dir="ltr"
                            id="telephone"
                            name="telephone"
                            :disabled="checkIfShopRejectedByShaparak()"
                            v-model="form_data.telephone"
                        >
                        </kt-form-control>
                    </kt-form-group>
                </kt-col>
                <kt-col lg="6" md="6" xs="12">
                    <kt-form-group>
                        <kt-form-label for="phone_number">
                            {{ $t('label.phone_number') }}
                        </kt-form-label>
                        <kt-form-control
                            dir="ltr"
                            id="phone_number"
                            name="phone_number"
                            :disabled="checkIfShopRejectedByShaparak()"
                            v-model="form_data.phone_number"
                        >
                        </kt-form-control>
                    </kt-form-group>
                </kt-col>
                <kt-col lg="6" md="6" xs="12" v-if="form_data.birth_crtfct_number">
                    <kt-form-group>
                        <kt-form-label for="birth_crtfct_number">
                            {{ $t('label.birth_crtfct_number') }}
                        </kt-form-label>
                        <kt-form-control
                            dir="ltr"
                            id="birth_crtfct_number"
                            name="birth_crtfct_number"
                            :disabled="checkIfShopRejectedByShaparak()"
                            v-model="form_data.birth_crtfct_number"
                        >
                        </kt-form-control>
                    </kt-form-group>
                </kt-col>
                <kt-col lg="6" md="6" xs="12" v-if="form_data.tax_payer_code !== null">
                    <kt-form-group>
                        <kt-form-label for="tax_payer_code">
                            {{ $t('label.tax_payer_code') }}
                        </kt-form-label>
                        <kt-form-control
                            dir="ltr"
                            id="tax_payer_code"
                            name="tax_payer_code"
                            :disabled="checkIfShopRejectedByShaparak()"
                            v-model="form_data.tax_payer_code"
                        >
                        </kt-form-control>
                    </kt-form-group>
                </kt-col>
            </kt-row>
            <!-- <kt-row>
                <kt-col xs="12">
                    <kt-form-group>
                        <kt-form-label for="sheba_number">
                            {{ $t('label.sheba_number') }}
                        </kt-form-label>
                        <select
                            id="sheba_number"
                            name="sheba_number"
                            v-model="form_data.sheba"
                            class="form-control kt-selectpicker"
                            :disabled="form_data && form_data.status === gatewayStatus.ACTIVE"
                        >
                            <option
                                v-bind:key="sheba_number.id"
                                v-for="sheba_number in iban_list"

                                :value="sheba_number.id"
                            >
                                {{ sheba_number.number }} ({{shebaNumberShaparakStatusStr.get(sheba_number.status)}})
                            </option>
                        </select>
                    </kt-form-group>
                </kt-col>
            </kt-row> -->
            <kt-row>
                <kt-col lg="6" md="6" xs="12">
                    <kt-form-group>
                        <kt-form-label for="business_certificate_number">
                            {{ $t('label.certificate_number') }}
                        </kt-form-label>
                        <kt-form-control
                            dir="ltr"
                            id="business_certificate_number"
                            name="business_certificate_number"
                            v-model="form_data.business_certificate_number"
                        >
                        </kt-form-control>
                    </kt-form-group>
                </kt-col>
                <kt-col lg="6" md="6" xs="12">
                    <kt-form-group>
                        <kt-form-label for="site_address">
                            {{ $t('label.site_address') }}
                        </kt-form-label>
                        <kt-form-control
                                dir="ltr"
                                id="site_address"
                                name="site_address"
                                placeholder="https://mysite.ir/"
                                v-model="form_data.site_address">
                        </kt-form-control>
                    </kt-form-group>
                </kt-col>
                <kt-col lg="6" md="6" xs="12">
                    <kt-form-group>
                        <kt-form-label for="server_ip">
                            {{ $t('label.server_ip') }}
                        </kt-form-label>
                        <kt-form-control
                            dir="ltr"
                            id="server_ip"
                            name="server_ip"
                            disabled
                            v-model="form_data.server_ip"
                        >
                        </kt-form-control>
                    </kt-form-group>
                </kt-col>
            </kt-row>
            <kt-row>
                <div class="col-md-6" style="padding-top: 20px">
                    <div class="form-group form-check d-flex">
                        <label class="switch">
                            <input  type="checkbox" class="custom-control-input" id="has_limit2" name="has_limit"
                                    v-model="form_data.abroad_ips_only_by_user">
                            <span class="slider round"></span>
                        </label>
                        <p class="mx-3" dir="rtl">{{ $t('label.abroad_ip_limitation_by_user') }}</p>
                    </div>
                    <transition name="fade">
                        <kt-form-group v-if="form_data.abroad_ips_only_by_user">
                            <kt-form-label>
                                {{ $t('label.limit_amount') }}
                            </kt-form-label>
                            <div class="kt-input-icon kt-input-icon--right">
                    <span class="kt-input-icon__icon kt-input-icon__icon--right">
                        <span>{{ $t('label.rial') }}</span>
                    </span>
                                <kt-form-control
                                        type="text"
                                        dir="ltr"
                                        id="limit_amount"
                                        name="limit_amount"
                                        v-model="form_data.limit_amount_by_user"
                                >
                                </kt-form-control>
                            </div>
                        </kt-form-group>
                    </transition>
                </div>

                <div class="col-md-6" style="padding-top: 20px">
                    <div class="form-group form-check d-flex flex-column align-items-start">
                        <div class="d-flex align-items-center">
                            <label class="switch">
                                <input type="checkbox" class="custom-control-input" id="use_push_transaction" name="use_push_transaction"
                                       v-model="form_data.use_push_transaction">
                                <span class="slider round"></span>
                            </label>
                            <p class="mx-3 mb-0" dir="rtl">{{ $t('label.use_push_transaction') }}</p>
                        </div>
                        <p style="font-size: xx-small; color: red;" class="mx-3 mt-1" dir="rtl">{{ $t('label.use_push_transaction_description') }}</p>
                    </div>
                </div>
                <div class="col-md-6" style="padding-top: 20px">
                    <div class="form-group form-check d-flex flex-column align-items-start">
                        <div class="d-flex align-items-center">
                            <label class="switch">
                                <input type="checkbox" class="custom-control-input" id="callback_limitation_only_by_vpn" name="callback_limitation_only_by_vpn"
                                       v-model="form_data.callback_limitation_only_by_vpn">
                                <span class="slider round"></span>
                            </label>
                            <p class="mx-3 mb-0" dir="rtl">{{ $t('label.callback_limitation_by_vpn') }}</p>
                        </div>
                    </div>
                </div>


                <!-- <kt-col lg="6" md="6" xs="12">
                    <kt-form-group>
                        <kt-form-label for="server_ip">
                            {{ $t('label.sds') }}
                        </kt-form-label>
                        <kt-form-control
                                dir="ltr"
                                id="server_ip"
                                name="phone_number"
                                disabled
                                value="878899"
                        >
                        </kt-form-control>
                    </kt-form-group>
                </kt-col> -->

                <kt-col lg="6" md="6" xs="12">
                    <kt-form-group>
                        <kt-form-label>
                            {{ $t('label.logo') }}
                        </kt-form-label>
                        <kt-form-label for="logo_file" class="d-block btn btn-secondary btn-wide label-file">
                            <kt-icon type="fa" name="paperclip"></kt-icon>
                            {{ $t('gateway.btn.click_me') }}
                        </kt-form-label>
                            <input
                                @change="processLogoFile"
                                type="file"
                                class="custom-file-upload"
                                name="logo"
                                id="logo_file"
                                accept="image/*"
                            />
                    </kt-form-group>
                </kt-col>
            </kt-row>
        </kt-form-section>

        <kt-form-action class="mt-4">
            <kt-button
                class="m-2"
                size="md"
                variant="success"
                type="submit"
                v-bind:wide="true"
                id="submit_btn"
            >
                {{ $t('panel.profile.update.wizard.form.btn.submit') }}
            </kt-button>
        </kt-form-action>
    </kt-col>
</form>
</template>

<script>
import { subcategories } from '@/constants/subcategories'
import { gatewayStatus } from '@/constants/gatewayStatus'
import $ from 'jquery'
import Inputmask from 'inputmask'
import { mapGetters, mapState } from 'vuex'
import { i18n } from '@/plugins/i18n'
import { userTypes } from '@/constants/userTypes';
import {shebaNumberShaparakStatusStr} from "../../../constants/shebaNumberShaparakStatus";
import { province_codes, provinceCities } from '@/constants/cityAndProvinceCodes';

export default {
    props: {
        submit: {
            default: () => {},
            type: Function
        },
        form_data: {
            default() {
                return {}
            },
            type: Object
        }
    },
    data() {
        return {
            user_types: userTypes,
            subcategories: subcategories,
            provinceCodes: province_codes,
            gatewayStatus: gatewayStatus
        }
    },
    mounted() {
        let params = {
            hashid: this.$route.params.hashid,
            shop_type: 1,
        }
        this.$store.dispatch('shebaNumber/fetchIbanList', params)
        .finally(() => {
            this.$store.dispatch('address/fetch').finally(() => {
                this.afterDispatch()
            })
        })
    },
    methods: {
        afterDispatch() {
            setTimeout(function () {
                $('.kt-selectpicker').selectpicker({
                    size: 4,
                    liveSearch: true,
                    noneResultsText: i18n.t('selectpicker.none_result'),
                    selectAllText: i18n.t('selectpicker.select_all'),
                    noneSelectedText: i18n.t('selectpicker.nothing_selected')
                })
            }, 2000)

            document.getElementById('phone_number') && Inputmask('099-99999999').mask(document.getElementById('telephone'))
            document.getElementById('telephone') && Inputmask('09999999999').mask(document.getElementById('phone_number'))

        },
        processLogoFile(e) {
            this.form_data.logo = event.target.files[0];
            if (this.validateSize(event.target)) {
                this.validateFormat(event.target);
            }
        },
        validateSize(file) {
            var FileSize = file.files[0].size / 1024 / 1024; // in MB
            if (FileSize > 1) {
                alert(i18n.t('authenticate.hint.fourth'));
                $(file).val('');
                return false;
            } else {

            }

            return true;
        },
        validateFormat(file) {
            let jq_file = $(file);
            let file_name = jq_file.val();
            let extension = file_name.replace(/^.*\./, '');
            if (extension === file_name) {
                extension = '';
            } else {
                extension = extension.toLowerCase();
            }

            switch (extension) {
                case "png":
                case "jpeg":
                case "jpg":
                    break;
                default:
                    alert(i18n.t('authenticate.input_format_err'));
                    $(file).val('');
                    return false;
            }

            return true;
        },
        checkIfShopRejectedByShaparak() {
            return this.form_data.status != gatewayStatus.REJECTED_BY_SHAPARAK
        }
    },
    computed: {
        shebaNumberShaparakStatusStr() {
            return shebaNumberShaparakStatusStr
        },
        ...mapGetters('address', [
            'addresses'
        ]),
        ...mapGetters('shebaNumber', [
            'iban_list'
        ]),
        ...mapGetters('user', [
            'current_user'
        ]),
        getProvinceCities() {
            return provinceCities(this.form_data.province_code)
        }
    },
}
</script>

<style scoped>
.label-file {
    border: 1px solid #ccc;
    width: fit-content;
    cursor: pointer;
    min-width: 200px;
}
input[type="file"]::-webkit-file-upload-button {
    visibility: hidden;
}
</style>